import { render, staticRenderFns } from "./RefrigerantSummary.vue?vue&type=template&id=1906a496&scoped=true&"
import script from "./RefrigerantSummary.vue?vue&type=script&lang=js&"
export * from "./RefrigerantSummary.vue?vue&type=script&lang=js&"
import style0 from "./RefrigerantSummary.vue?vue&type=style&index=0&id=1906a496&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1906a496",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
